import { useLayoutEffect } from 'react'
import { AppSelection, Sidebar as SidebarDS } from '@iveco-ti/iveco-ds'
import { Home, LayoutGrid, PanelLeftClose } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Link, useLocation } from 'react-router'

import LogoImg from '@/assets/images/logo.svg?url'
import { ROUTES } from '../constants/routes'
import { useActiveGeneralSettings } from '../hooks/useActiveGeneralSettings'
import { useAppConfig } from '../hooks/useAppConfig'
import { QuickAccess } from '../models/generalSettings'

export function Sidebar() {
  const { t } = useTranslation('common')
  const { pathname } = useLocation()
  const { settings } = useActiveGeneralSettings()
  const { APPS } = useAppConfig()

  useLayoutEffect(() => {
    window?.HSStaticMethods?.autoInit()
  }, [APPS])

  return (
    <SidebarDS.Root id="sidebar">
      <SidebarDS.Header
        alt="Logo"
        logo={LogoImg}
        iconClose={<PanelLeftClose />}
      />

      <SidebarDS.Nav>
        <Link to={ROUTES.PANEL.NEWS}>
          <SidebarDS.Link
            icon={Home}
            text={t('authenticated_layout.menus.panel')}
            active={pathname === ROUTES.PANEL.NEWS}
          />
        </Link>
      </SidebarDS.Nav>

      {APPS.length > 0 &&
        settings?.quickAccess &&
        settings?.features.show_quick_access !== QuickAccess.TOOLS && (
          <SidebarDS.Footer>
            <AppSelection
              apps={APPS}
              app={{
                logo: <LayoutGrid size={22} className="" />,
                name: t('sidebar.app_selection.quick_access'),
              }}
            />
          </SidebarDS.Footer>
        )}
    </SidebarDS.Root>
  )
}
